import * as tslib_1 from "tslib";
import setInboxRuleService from '../services/setInboxRuleService';
import { action } from 'satcheljs/lib/legacy';
import datapoints from '../datapoints';
import InboxRuleRetryDialog from '../components/InboxRuleRetryDialog';
import { logUsage } from 'owa-analytics';
import resetInboxRuleEdit from './resetInboxRuleEdit';
import getInboxRules from './getInboxRules';
import runRuleNow from '../actions/actionCreators/runRuleNow';
import canRunRule from 'owa-inbox-rules-option/lib/utils/canRunRule';
export default action('setInboxRuleAction', datapoints.setInboxRuleDatapoint)(function setInboxRuleAction(inboxRule, shouldRunRuleNow, force, alwaysDeleteOutlookRulesBlob) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/, setInboxRuleService(inboxRule, force, alwaysDeleteOutlookRulesBlob)
                    .then(function (response) {
                    if (!response.WasSuccessful) {
                        // show retry dialog if request failed and UserPrompt
                        if (response.UserPrompt) {
                            var dialog = new InboxRuleRetryDialog(response.UserPrompt, function (isChecked) {
                                return setInboxRuleAction(inboxRule, shouldRunRuleNow, true /*force*/, isChecked /*alwaysDeleteOutlookRulesBlob*/);
                            }, function () { });
                            return dialog.show();
                        }
                        logUsage(datapoints.inboxRuleActionFailDatapoint.datapoint.name, [
                            'SetInboxRule',
                        ]);
                    }
                    if (shouldRunRuleNow && canRunRule(inboxRule)) {
                        runRuleNow(inboxRule);
                    }
                    resetInboxRuleEdit();
                    // re-fetch the rules list if successful
                    getInboxRules();
                    return Promise.resolve();
                })
                    .catch(function (error) {
                    logUsage(datapoints.inboxRuleActionFailDatapoint.datapoint.name, ['SetInboxRule']);
                    return Promise.resolve();
                })];
        });
    });
});
//# sourceMappingURL=setInboxRuleAction.js.map